import AvatarGroup from './AvatarGroup';

// export types
export type { AvatarGroupProps } from './AvatarGroup';

// export components
export { AvatarGroup };
export default AvatarGroup;
